import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose, isNil, equals } from 'ramda';

import { Gallery, GallerySlide } from './experienceGallery.styles';
import { ImageSlide } from './imageSlide';
import { VideoSlide } from './videoSlide';

export class ExperienceGalleryComponent extends Component {
  static propTypes = {
    placeholder: PropTypes.bool,
    className: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        imageAsset: PropTypes.string,
        videoAsset: PropTypes.string,
      })
    ),
  };

  state = {
    activeSlide: 0,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !equals(this.state, nextState) || !equals(this.props, nextProps);
  }

  get isVideoSlideActive() {
    if (this.props.placeholder) {
      return false;
    }

    const activeSlideData = this.props.items[this.state.activeSlide];
    return !isNil(activeSlideData.videoAsset);
  }

  get items() {
    return this.props.placeholder ? [{ key: '1', placeholder: true }] : this.props.items;
  }

  galleryRef = React.createRef();

  handleSlideChange = activeSlide => this.setState({ activeSlide });

  handleSlideEnded = () => this.galleryRef.current.nextSlide();

  renderSlide = ({ key, imageAsset, videoAsset }, slideIndex) => {
    const props = {
      image: imageAsset,
      video: videoAsset,
      isActive: this.state.activeSlide === slideIndex,
      onSlideEnded: this.handleSlideEnded,
    };

    const SlideComponent = videoAsset ? VideoSlide : ImageSlide;

    return (
      <GallerySlide key={imageAsset || key}>
        <SlideComponent {...props} />
      </GallerySlide>
    );
  };

  render() {
    const { className } = this.props;

    return (
      <Gallery
        ref={this.galleryRef}
        className={className}
        autoplay={!this.isVideoSlideActive}
        options={{
          dots: true,
          autoplaySpeed: 10000,
          afterChange: this.handleSlideChange,
        }}
      >
        {this.items.map(this.renderSlide)}
      </Gallery>
    );
  }
}

export const ExperienceGallery = compose(injectIntl)(ExperienceGalleryComponent);
